import {dashboardPluginService} from '@/common/api.service'

const initialStates = {
    status: 'loading',
    starshopDashboard: {
        login_log: [],
        user_data: [],
        admin_data: []
    },
    active_board: 1,
}

const mutations = {
    loading(state) {
        state.status = 'loading'
        state.starshopDashboard = {
            login_log: [],
            user_data: [],
            admin_data: []
        }
    },
    success(state, starshopDashboard) {
        state.status    = 'success'
        state.starshopDashboard = starshopDashboard
    },
    fail(state) {
        state.status    = 'fail'
        state.starshopDashboard = []
    },
    setBoard(state, value) {
        state.active_board = value
    },
}

const getters = {
    status: state => state.status,
    starshopDashboard: state => state.starshopDashboard
}

const actions = {
    fetchStarshopDashboard({commit}) {
        commit('loading')
        return dashboardPluginService.fetchStarShopDashboard().then(response => {
            commit('success', response.data.data)
        })
    },
    refreshStarshopDashboard({commit}) {
        commit('loading')
        return dashboardPluginService.refreshStarShopDashboard().then(response => {
            commit('success', response.data.data)
        })
    },
}

export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}